module.exports = __webpack_public_path__ + "img/baidu_icon.0adad3c9.png";